import React from 'react';
import PropTypes from 'prop-types';

import ErrorPage from 'components/ErrorPage/ErrorPage';

const propTypes = {
  error: PropTypes.shape({}).isRequired,
};

// For some reason passing ErrorPage to the <ErrorBoundary> component directly
// results in an error.
export function UnstyledErrorBoundaryFallback({ error }) {
  return (
    <div role="alert">
      <ErrorPage error={error} />
    </div>
  );
}

UnstyledErrorBoundaryFallback.propTypes = propTypes;

export default UnstyledErrorBoundaryFallback;
